import Auth from "../Auth/Auth";
import { DefaultLayout } from "./DefaultLayout";

export default Auth(DefaultLayout);
